module.exports = __webpack_public_path__ + "img/Flag_of_Romania.15da9998.svg";